import {
  MANUFACTURER,
  LIST_OF_MANUFACTURER,
  CREATE_MANUFACTURER,
} from "./ApiRoutes";
import { authData } from "./services";

export const listOfManufacturer = async (data: object) => {
  const response = await authData.post(LIST_OF_MANUFACTURER, data);
  return response?.data;
};

export const createManufacturer = async (data: object) => {
  const response = await authData.post(CREATE_MANUFACTURER, data);
  return response?.data;
};

export const deleteManufacturer = async (id: number) => {
  const response = await authData.delete(`${MANUFACTURER}${id}`);
  return response?.data;
};

export const editManufacturer = async (id: number, data: object) => {
  const response = await authData.put(`${MANUFACTURER}${id}`, data);
  return response?.data;
};
